module.exports = __webpack_public_path__ + "static/media/03_01.3dec86b0.png";